"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DateRange = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _formFieldPropTypes = require("../../../../../propTypes/formFieldPropTypes");
var _InputText = require("../../InputText");
var _helpers = require("../../../../../helpers");
const _excluded = ["fieldFormContext", "minDate", "maxDate"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const DateRange = _ref => {
  let {
      fieldFormContext,
      minDate,
      maxDate
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const {
    clearErrors
  } = formContext;
  const minDateTimeStamp = minDate.getTime();
  const maxDateTimeStamp = maxDate.getTime();
  const minPropValue = (0, _helpers.DateToShortIsoString)(minDate);
  const maxPropValue = (0, _helpers.DateToShortIsoString)(maxDate);
  const isValidDate = dateString => {
    const dateValue = new Date(dateString);
    const dateValueTimeStamp = dateValue.getTime();
    if (dateValueTimeStamp < minDateTimeStamp) {
      return "The date you entered should not be before ".concat((0, _helpers.DateToShortReadableDate)(minDate));
    }
    if (dateValueTimeStamp > maxDateTimeStamp) {
      return "The date you entered should not be after ".concat((0, _helpers.DateToShortReadableDate)(maxDate));
    }
    clearErrors(rest.name);
    return true;
  };
  const customValidation = _objectSpread(_objectSpread({}, rest.validation), {}, {
    min: minDate.toDateString(),
    max: maxDate.toDateString(),
    validate: _objectSpread(_objectSpread({}, rest.validation && rest.validation.validate || {}), {}, {
      min: isValidDate,
      max: isValidDate
    }),
    valueAsDate: true
  });
  return /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    inputType: "date",
    min: minPropValue,
    max: maxPropValue
  }, rest, {
    fieldFormContext: formContext,
    validation: customValidation
  }));
};
exports.DateRange = DateRange;
DateRange.propTypes = _formFieldPropTypes.FormFieldPropTypes;
var _default = exports.default = DateRange;